import React from 'react';
import AddPurchaseFunctional from './components/add-purchase-functional';
import './styles.scss';

const AddPurchase = ({ state, setState, refreshList, editData }) => {
	return <AddPurchaseFunctional {...{ state, setState, refreshList, editData }} />;
};

export default AddPurchase;
